import React, { useState, useEffect } from 'react';
import { Box, Button, Grid, TextField, Typography } from '@mui/material';
import { FieldArray, FormikProvider } from 'formik';
import MenuItem from '@mui/material/MenuItem';
import 'dayjs/locale/ko';
import * as dayjs from 'dayjs'

import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'; 
import DateAdapter from '@mui/lab/AdapterDateFns';

import BaseCodeSelectbox from '../../common/form/selectbox/BaseCodeSelectbox';
import moment from 'moment';

const TechMidForm = ({ formik, techMid }) => {
  const [rptStrtDt, setRptStrtDt] = useState(null);
  const [rptEndDt, setRptEndDt] = useState(null);
  const [rptTotTm, setRptTotTm] = useState(0);
  const [hourOptions, setHourOptions] = useState([]);

  useEffect(() => {
    if (techMid) {
      if (techMid?.rptStrtDt) setRptStrtDt(techMid.rptStrtDt);
      if (techMid?.rptEndDt) setRptEndDt(techMid.rptEndDt);
    }
  }, [techMid]);

  const onChangeDate = (newValue, name) => {
    formik.setFieldValue(name, newValue);
  };

  useEffect(() => {
    if (
      rptStrtDt !== null &&
      rptStrtDt !== '' &&
      rptEndDt !== null &&
      rptEndDt !== ''
    ) {
      let stringStartDt = '';
      let stringEndDt = '';
      let stringStartFormat = '';
      let stringEndFormat = '';

      if (formik.values.rptStrtHr !== '00') {
        stringStartDt =
          moment(rptStrtDt).format('YYYY-MM-DD') +
          ' ' +
          formik.values.rptStrtHr;
        stringStartFormat = 'YYYY-MM-DD HH';
      } else {
        stringStartDt = rptStrtDt;
        stringStartFormat = 'YYYY-MM-DD';
      }
      if (formik.values.rptEndHr !== '00') {
        stringEndDt =
          moment(rptEndDt).format('YYYY-MM-DD') + ' ' + formik.values.rptEndHr;
        stringEndFormat = 'YYYY-MM-DD HH';
      } else {
        stringEndDt = rptEndDt;
        stringEndFormat = 'YYYY-MM-DD';
      }

      const startDt = moment(stringStartDt).format(stringStartFormat);
      const endDt = moment(stringEndDt).format(stringEndFormat);

      //작업시간
      const dif = moment
        .duration(moment(endDt).diff(moment(startDt)))
        .asHours();
      setRptTotTm(dif);
      formik.setFieldValue('rptTotTm', dif);
    }
  }, [rptStrtDt, rptEndDt, formik.values?.rptStrtHr, formik.values?.rptEndHr]);

  useEffect(() => {
    if (hourOptions.length === 0) {
      let hourArr = [];
      for (let index = 0; index < 24; index++) {
        let hourString =
          index.toString().length < 2 ? '0' + index : index.toString();
        hourArr.push(hourString);
      }
      setHourOptions(hourArr);
    }
  }, [hourOptions]);

  return (
    <Grid
      container
      direction="column"
      justifyContent="flex-start"
      alignItems="flex-start"
      sx={{ my: 1 }}
    >
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        spacing={1}
      >
        <Grid item xs={2}>
          <BaseCodeSelectbox
            formik={formik}
            filterObject={{
              blcCd: 'BASE',
              mlcCd: 'TECH',
              slcCd: 'RSLT_TYP',
              useYn: 'Y',
            }}
            name="rptTyp"
            label="중간 보고서 종류"
            margin="normal"
          />
        </Grid>
        <Grid item xs={10}>
          <TextField
            margin="normal"
            required
            variant="outlined"
            fullWidth
            id="rptTitle"
            name="rptTitle"
            label="중간 보고서명"
            value={formik.values.rptTitle}
            onChange={formik.handleChange}
            error={formik.touched.rptTitle && Boolean(formik.errors.rptTitle)}
            helperText={formik.touched.rptTitle && formik.errors.rptTitle}
          />
        </Grid>
      </Grid>

      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        spacing={1}
      >
        <Grid item xs={2}>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
            <DatePicker
              clearable
              label="작업 시작일"
              format="YYYY-MM-DD"
              mask={'____-__-__'}
              id="rptStrtDt"
              name="rptStrtDt"
              value={dayjs(rptStrtDt)}
              onChange={(newValue) => {
                setRptStrtDt(dayjs(newValue));
                onChangeDate(dayjs(newValue), 'rptStrtDt');
              }}
              slotProps={{
                textField: {
                  fullWidth: true,
                  margin: "normal",
                  variant: "outlined",
                  error: formik.touched.rptStrtDt && Boolean(formik.errors.rptStrtDt),
                  helperText: formik.touched.rptStrtDt && formik.errors.rptStrtDt,
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={2}>
          <TextField
            margin="normal"
            required
            variant="outlined"
            fullWidth
            select
            id="rptStrtHr"
            name="rptStrtHr"
            label="작업시작시간"
            InputLabelProps={{ shrink: true }}
            value={formik.values.rptStrtHr}
            onChange={(e) => onChangeDate(e.target.value, 'rptStrtHr')}
            error={formik.touched.rptStrtHr && Boolean(formik.errors.rptStrtHr)}
            helperText={formik.touched.rptStrtHr && formik.errors.rptStrtHr}
          >
            {hourOptions &&
              hourOptions.map((hour, index) => (
                <MenuItem key={index} value={hour}>
                  {hour}
                </MenuItem>
              ))}
          </TextField>
        </Grid>

        <Grid item xs={2}>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ko">
            <DatePicker
              clearable
              label="작업 종료일"
              format="YYYY-MM-DD"
              mask={'____-__-__'}
              id="rptEndDt"
              name="rptEndDt"
              value={dayjs(rptEndDt)}
              onChange={(newValue) => {
                setRptEndDt(dayjs(newValue));
                onChangeDate(dayjs(newValue), 'rptEndDt');
              }}
              slotProps={{
                textField: {
                  margin: "normal",
                  variant: "outlined",
                  fullWidth: true,
                  error: formik.touched.rptEndDt && Boolean(formik.errors.rptEndDt),
                  helperText: formik.touched.rptEndDt && formik.errors.rptEndDt,
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={2}>
          <TextField
            margin="normal"
            required
            variant="outlined"
            fullWidth
            select
            id="rptEndHr"
            name="rptEndHr"
            label="작업종료시간"
            InputLabelProps={{ shrink: true }}
            value={formik.values.rptEndHr}
            onChange={(e) => onChangeDate(e.target.value, 'rptEndHr')}
            error={formik.touched.rptEndHr && Boolean(formik.errors.rptEndHr)}
            helperText={formik.touched.rptEndHr && formik.errors.rptEndHr}
          >
            {hourOptions &&
              hourOptions.map((hour, index) => (
                <MenuItem key={index} value={hour}>
                  {hour}
                </MenuItem>
              ))}
          </TextField>
        </Grid>
        <Grid item xs={4}>
          <Typography variant="body2" component="div">
            총 작업시간은 {rptTotTm}시간 입니다
          </Typography>
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        spacing={1}
      >
        <Grid item xs={12}>
          <TextField
            margin="normal"
            required
            variant="outlined"
            fullWidth
            multiline
            rows={5}
            id="rptContext"
            name="rptContext"
            label="중간보고서 내용"
            InputLabelProps={{ shrink: true }}
            value={formik.values.rptContext}
            onChange={formik.handleChange}
            error={
              formik.touched.rptContext && Boolean(formik.errors.rptContext)
            }
            helperText={formik.touched.rptContext && formik.errors.rptContext}
          />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default TechMidForm;
